import React, {useState} from 'react';
import {Container, Row, Col} from 'reactstrap';

import image1 from "../../../assets/images/Project/2.png";
import image2 from "../../../assets/images/Project/2.png";
import image3 from "../../../assets/images/Project/3.png";
import {useTranslation} from 'react-i18next';
import {appConfig} from '../../../config';

const Products = () => {
    const {t} = useTranslation();

    const [nav, setNav] = useState("All");

    return (
        <React.Fragment>
            <section className="section bg-light" id="marketplace">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div className="text-center mb-5">
                                <h2 className="mb-3 fw-semibold lh-base">
                                    {t('t-fact-pros-head')}
                                </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} className="product-item">
                            <div className="card explore-box card-animate h-100">
                                <div className="text-center mt-4 p-2">
                                    <span className="rounded-circle badge badge-soft-success p-3">
                                        <img className='avatar-sm' src={image1} alt=''/>
                                    </span>
                                </div>
                                <div className="card-body">
                                    <h3 className="text-center">{t('t-fact-pros1')}</h3>
                                    <p className="text-muted my-2 text-center fs-17 pt-3">
                                        {t('t-fact-pros1-desc')}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} className="product-item">
                            <div className="card explore-box card-animate h-100">
                                <div className="text-center mt-4 p-2">
                                    <span className="rounded-circle badge badge-soft-success p-3">
                                        {/* <i className="ri-bar-chart-2-fill" style={{ fontSize: "3rem" }}></i> */}
                                        <img className='avatar-sm' src={image2} alt=''/>
                                    </span>
                                </div>
                                <div className="card-body">
                                    <h3 className="text-center">{t('t-fact-pros2')}</h3>
                                    <p className="text-muted my-2 text-center fs-17 pt-3">
                                        {t('t-fact-pros2-desc').split('{appName}')[0]}
                                        <span className='fw-semibold'>{appConfig.appName}</span>
                                        {t('t-fact-pros2-desc').split('{appName}')[1]}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} className="product-item">
                            <div className="card explore-box card-animate h-100">
                                <div className="text-center mt-4 p-2">
                                    <span className="rounded-circle badge badge-soft-success p-3">
                                        {/* <i className="ri-eye-fill" style={{ fontSize: "3rem" }}></i> */}
                                        <img className='avatar-sm' src={image3} alt=''/>
                                    </span>
                                </div>
                                <div className="card-body">
                                    <h3 className="text-center">{t('t-fact-pros3')}</h3>
                                    <p className="text-muted my-2 text-center fs-17 pt-3">
                                        {t('t-fact-pros3-desc').split('{appName}')[0]}
                                        <span className='fw-semibold'>{appConfig.appName}</span>
                                        {t('t-fact-pros3-desc').split('{appName}')[1]}
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Products;
